import { luscinia } from "../luscinia";
import { v4 as uuidv4 } from 'uuid';

luscinia.renderParameterFormModal = async (parameterFullClassName: string, modalTitle: string, onSave: ($modal: JQuery) => void, testId?: string) => {
    const response = await fetch("/parameter/render-as-form/" + parameterFullClassName, {
        method: "POST",
    });

    const $content = $(await response.text());

    renderModal(
        modalTitle,
        () => $content,
        ($modal: JQuery) => {
            const footer = $(`
                <div>
                  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary">Save changes</button>
                </div>
              `);
            footer.find(".btn-primary").on("click", () => {
                onSave($modal);
            });
            return footer;
        },
        testId
    );
};

function renderModal(title: string, renderContent: ($modal: JQuery) => JQuery<HTMLElement>, renderFooter: ($modal: JQuery) => JQuery<HTMLElement>, testId?: string) {
    const zIndex = getHighestZIndex(".modal:visible") + 2048;
    const id = uuidv4();
    const $modal = $(`
        <div id="${id}" class="modal fade colored-header" style="z-index: ${zIndex};" tabindex="-1" role="dialog">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">${title}</h4>
                        </div>
                        <div class="modal-body">
                        </div>
                        <div class="modal-footer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `);

    if (testId) {
        $modal.attr("test-id", testId);
    }

    $modal.find(".modal-body").append(renderContent($modal));
    $modal.find(".modal-footer").append(renderFooter($modal));
    $modal.on("hidden.bs.modal", function () {
        $(this).remove();
    });

    $("body").append($modal);

    if ($modal.find(".modal-body").find("form").length > 0) {
        luscinia.initFormElements($(`#${id}`), $(`#${id}`).find("form"));
    }

    $modal.modal("show");
    return $modal;
}

function getHighestZIndex(selector: string) {
    const elements = $(selector);
    let highestZIndex = 0;
    elements.each((element, el) => {
        const zIndex = parseInt($(el).css("z-index"), 10);
        if (!isNaN(zIndex) && zIndex > highestZIndex) {
            highestZIndex = zIndex;
        }
    });
    return highestZIndex;
}
